import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NewsTab, LawsTab, DigestsTab, StatisticsTab, RiskCardTab, CalendarTab } from './tabs';
import { checkUserExpirationDateExpired } from '~utils/helpers';

function Nav({ isNewsUserLogged, isLawsUserLogged, isNewsAvailable, isLawsAvailable, ecosystemFunctions, onClick }) {
    const isUserLogged = isNewsUserLogged || isLawsUserLogged;
    return (
        <nav>
            {!isUserLogged ? (
                <NewsTab onClick={onClick} />
            ) : isNewsUserLogged && isNewsAvailable ? (
                <NewsTab onClick={onClick} />
            ) : null}
            {!isUserLogged ? (
                <LawsTab onClick={onClick} />
            ) : isLawsUserLogged && isLawsAvailable ? (
                <LawsTab onClick={onClick} />
            ) : null}
            {isLawsUserLogged && ecosystemFunctions instanceof Object && ecosystemFunctions.create_digests && (
                <DigestsTab onClick={onClick} />
            )}
            {isLawsUserLogged && ecosystemFunctions instanceof Object && ecosystemFunctions.create_reports && (
                <StatisticsTab onClick={onClick} />
            )}
            {isLawsUserLogged && ecosystemFunctions instanceof Object && ecosystemFunctions.create_risk_map && (
                <RiskCardTab onClick={onClick} />
            )}
            {isUserLogged ? <CalendarTab onClick={onClick} /> : null}
        </nav>
    );
}

Nav.propTypes = {
    isNewsUserLogged: PropTypes.bool,
    isLawsUserLogged: PropTypes.bool,
    isNewsAvailable: PropTypes.bool,
    isLawsAvailable: PropTypes.bool,
    ecosystemFunctions: PropTypes.object,
    onClick: PropTypes.func,
};

const mapStateToProps = (state) => ({
    isNewsUserLogged: !checkUserExpirationDateExpired(state.user.newsUser.token_expires_at),
    isLawsUserLogged: !checkUserExpirationDateExpired(state.user.lawsUser.token_expires_at),
    isNewsAvailable: state.user.feed_settings && state.user.feed_settings.news,
    isLawsAvailable: state.user.feed_settings && state.user.feed_settings.laws,
    ecosystemFunctions: state.user.ecosystem.functions,
});

export default connect(mapStateToProps)(Nav);



// WEBPACK FOOTER //
// ./src/components/navigation/nav/index.js